import { useMemo } from 'react';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';

export const useCanceledOptions = (): Record<string, string> => {
  const tOptions = useTranslationPrefix('approvals.approvals_view.cancel_decline_reasons.options');

  return useMemo(
    () => ({
      access: tOptions('access'),
      'customer-cancellation': tOptions('customer_cancellation'),
      equipment: tOptions('equipment'),
      hangar: tOptions('hangar'),
      'maintenance-conflict': tOptions('maintenance_conflict'),
      manpower: tOptions('manpower'),
      'missed-ops-error': tOptions('missed_ops_error'),
      'hours-of-operation': tOptions('hours_of_operation'),
      'insufficient-notice': tOptions('insufficient_notice'),
      weather: tOptions('weather'),
      'special-event-volume': tOptions('special_event_volume'),
      duplicate: tOptions('duplicate'),
      other: tOptions('other'),
    }),
    [tOptions],
  );
};
